export enum REWARDS_QR_CODE_TYPES {
    barcode_1d = "barcode_1d",
    barcode_2d = "barcode_2d",
}

export interface DownloadImageOptions {
    logo: string | null;
    description: string;
    shopDomain: string;
}
